
import BrandStatusToggle from "./BrandStatusToggle";
import { getProgramId } from "../utils";
import FeaturedToggle from "./FeaturedToggle";

export default function BrandsListing({
  brands,
  isSavingOrder,
  togglingIds,
  onToggleStatus,
  onToggleFeature,
  onPreviewImage,
  onEdit,
  onOpenOffers,
}) {
  if (!brands || brands.length === 0) {
    return (
      <tbody className="divide-y divide-gray-100 bg-white">
        <tr>
          <td
            className="px-6 py-6 text-sm text-gray-500 text-center"
            colSpan={6}
          >
            No brands found.
          </td>
        </tr>
      </tbody>
    );
  }

  return (
    <tbody className="divide-y divide-gray-100 bg-white">
      {brands.map((brand, index) => {
        const brandId = getProgramId(brand);
        const isToggling = togglingIds?.includes(brandId);

        return (
          <tr key={brandId || index} className="text-sm text-gray-700">
            {/* Sr No. */}
            <td className="px-6 py-4 font-semibold text-gray-900">
              {index + 1}
            </td>

            {/* Brand Logo */}
            <td className="px-6 py-4">
              {brand.brand_logo ? (
                <button
                  type="button"
                  onClick={() => onPreviewImage?.(brand.brand_logo, brand.brand_name_en || brand.title_en || "Brand logo")}
                  className="inline-flex cursor-pointer rounded-md border border-gray-200 bg-white p-1 transition hover:border-cyan-300 hover:shadow-sm"
                >
                  <img
                    src={brand.brand_logo}
                    alt={brand.title_en}
                    className="h-10 w-10 object-contain"
                  />
                </button>
              ) : (
                "—"
              )}
            </td>

            {/* Brand Name */}
            <td className="px-6 py-4 font-semibold text-gray-900">
              {brand.brand_name_en || brand.title_en || brand.brand_name || brand.name || "—"}
            </td>

            {/* Status */}
            <td className="px-6 py-4">
              <BrandStatusToggle
                programTitle={brand.title_en || brand.brand_name_en || brand.brand_name || "Brand"}
                status={brand.status}
                disabled={!brandId || isToggling || isSavingOrder}
                isUpdating={isToggling}
                onToggle={() => onToggleStatus(brand)}
              />
            </td>

            {/* Feature */}
            {/* <td className="px-6 py-4">
              <FeaturedToggle
                brandTitle={brand.title_en}
                isFeatured={brand.featured}
                disabled={!brandId || isToggling || isSavingOrder}
                isUpdating={isToggling}
                onToggle={() => onToggleFeature(brand)}
              />
            </td> */}

            {/* Action */}
            <td className="px-6 py-4">
              {brandId ? (
                <div className="flex items-center gap-4">
                <button
                  type="button"
                  className="text-sm font-semibold text-cyan-600 hover:text-cyan-700"
                  onClick={() => onEdit(brandId)}
                >
                  Edit
                </button>
                <button
                  type="button"
                  className="text-sm font-semibold text-cyan-600 hover:text-cyan-700"
                  onClick={() => onOpenOffers(brand)}
                >
                  Offers
                </button>
              </div>
              ) : (
                "—"
              )}
            </td>
          </tr>
        );
      })}
    </tbody>
  );
}

